import { render, staticRenderFns } from "./GatDateEdit.vue?vue&type=template&id=a12ada76&scoped=true&"
import script from "./GatDateEdit.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GatDateEdit.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./GatDateEdit.vue?vue&type=style&index=0&id=a12ada76&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a12ada76",
  null
  
)

export default component.exports